import { render } from "./ClientInventarioCategorias.vue?vue&type=template&id=69ea5a83&scoped=true"
import script from "./ClientInventarioCategorias.vue?vue&type=script&lang=js"
export * from "./ClientInventarioCategorias.vue?vue&type=script&lang=js"

import "./ClientInventarioCategorias.vue?vue&type=style&index=0&id=69ea5a83&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69ea5a83"]])

export default __exports__